import { gql } from '@apollo/client/core';

export const buttonBlockFragment = gql`
  fragment ButtonBlockFields on ButtonBlock {
    buttonLabel
    redirectUrl
    openInNewTab
  }
`;
